
import expandableText from '@Shared/Common/Scripts/Components/_expandableText';
export default {
  components: {
    expandableText: expandableText
  },
  data: function data() {
    return {
      config: {},
      isExpandable: false
    };
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.windowResizeHandler);
  },
  methods: {
    init: function init(config) {
      this.config = config || {};
      this.windowResizeHandler();
      window.addEventListener('resize', this.windowResizeHandler);
    },
    windowResizeHandler: function windowResizeHandler(e) {
      var smallScreenSize = 766;

      if (window.innerWidth < smallScreenSize) {
        this.isExpandable = true;
      } else {
        this.isExpandable = false;
      }
    }
  }
};